import { DocumentDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/document-display-model";
import { AnfrageService } from "@/api/service-index";
import { PortalContextService } from "@/core/services/portal-context.service";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { of } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class GetAllAnfragenAttachmentsResolver implements Resolve<DocumentDisplayModel[] | null | undefined> {
  constructor(protected anfrageService: AnfrageService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService, protected portalContextService: PortalContextService){}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<DocumentDisplayModel[] | null | undefined> {
    let id: string = <string>route.params['id'];
    let sectionId: string = <string>route.params['abschnittid'];

    if (this.portalContextService.CurrentGutachten) {
      id = this.portalContextService.CurrentAnfrage.id;
    }

    await this.unfinishedHttpMethodsService.waitByUrl(state.url);

    if(this.portalContextService.CurrentAnfrage && this.portalContextService.CurrentAnfrage.id == id && this.portalContextService.CurrentAnfrage.attachments)
      return of(this.portalContextService.CurrentAnfrage.attachments.filter(attachment => attachment.documententyp?.sectionId == sectionId)).toPromise();

    return this.anfrageService.apiAnfrageAnfrageIdAttachmentGet({ anfrageId: id, loadContent: false, loadDocumentType: true, gutachtenId: this.portalContextService.CurrentGutachten?.gutachtenId ?? undefined  }).pipe(map(response => {
      if (response) {
        if(this.portalContextService.CurrentAnfrage?.id == id && !this.portalContextService.CurrentAnfrage?.attachments)
          this.portalContextService.CurrentAnfrage.attachments = response;

        if(this.portalContextService.CurrentAnfrage?.attachments)
          return this.portalContextService.CurrentAnfrage.attachments.filter(attachment => attachment.documententyp?.sectionId == sectionId);
      }

      return undefined;
    })).toPromise();
  }
}